(() => {
  const form = document.getElementById('fx-quote-form');
  if (!form) return;

  const optionalDetails = form.querySelector('[data-quote-optional]');
  if (optionalDetails && !form.querySelector('.fx-form-status-error')) {
    optionalDetails.open = false;
  }

  form.addEventListener('invalid', (event) => {
    if (optionalDetails && optionalDetails.contains(event.target)) {
      optionalDetails.open = true;
    }
  }, true);

  const params = new URLSearchParams(window.location.search);
  const requestedProduct = (params.get('product') || '').trim().slice(0, 200);
  const source = form.querySelector('#fx-src');
  if (source) source.value = window.location.pathname;

  const select = form.querySelector('#fx-psel');
  if (!select || !/^[a-z0-9][a-z0-9-]{0,199}$/i.test(requestedProduct)) return;

  const products = JSON.parse(form.querySelector('[data-quote-product-map]').textContent);
  const product = products.find((item) => item.handle === requestedProduct);
  const option = product && Array.from(select.options).find((item) => item.dataset.family === product.family);
  if (option) select.value = option.value;

  const productContext = form.querySelector('#fx-source-product');
  const title = product?.title || (params.get('title') || '').trim().slice(0, 160) || requestedProduct.replace(/-/g, ' ');
  if (productContext) {
    productContext.value = `${title} (${requestedProduct})`;
    productContext.disabled = false;
  }
  if (source) {
    source.value = `${window.location.pathname}?product=${encodeURIComponent(requestedProduct)}`;
  }
  const visibleContext = form.querySelector('[data-quote-context]');
  if (visibleContext) {
    visibleContext.querySelector('[data-quote-context-title]').textContent = title;
    const returnLink = visibleContext.querySelector('[data-quote-context-return]');
    if (product && returnLink) {
      returnLink.href = `/products/${encodeURIComponent(product.handle)}`;
      returnLink.hidden = false;
    }
    visibleContext.hidden = false;
  }
})();
